export default __webpack_public_path__ + "static/media/GE@3x.8d9487eb.png";